import React from "react";
import { useHistory } from "react-router-dom";
import LoggedOutLayout from "../components/LoggedOutLayout/LoggedOutLayout";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ButtonGhost, ButtonPrimary } from "../components";

const CenteredWrapper = styled.div`
  top: 0;
  left: 0;
  width: 100vw;
  height: 70vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    flex-direction: column;
  }
`;

export default function HomeScreen() {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <LoggedOutLayout>
      <CenteredWrapper>
        <ButtonGhost onClick={() => history.push("/recovery")}>
          {t("common.button.recovery")}
        </ButtonGhost>
        <ButtonPrimary onClick={() => history.push("/registration")}>
          {t("common.button.registration")}
        </ButtonPrimary>
      </CenteredWrapper>
    </LoggedOutLayout>
  );
}
